import React from 'react'
import Hero from '../sections/Hero'
import StatsBar from '../sections/StatsBar'
import PartnersBar from '../sections/PartnersBar'
import ActivitiesSection from '../sections/ActivitiesSection'

export default function Home() {
    return (
        <>
            <Hero />
            <StatsBar />
            <PartnersBar />
            <ActivitiesSection />
        </>
    )
}
